import { Box, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

interface SCardProps {
  title: string;
  children?: ReactNode;
}

const SCard = ({ title, children }: SCardProps) => {
  return (
    <Box bg="#E4F8F8" p={6} fontSize={12} borderRadius={16}>
      <Text fontWeight={600} fontSize={14} color="#3F6870" mb={8}>
        {title}
      </Text>
      {children}
    </Box>
  );
};

export default SCard;
